<template>
  <div class="funnel-container">
    <div class="funnel-left">
      <div v-for="(item, index) in itemData" :key="index" class="each-level">
        <p class="level-name">{{ item.name }}</p>
        <div class="level-value-img">
          <img class="level-img" :src="require(`../../../assets/img/funnel${index}.png`)" />
          <p :class="{ 'lebel-value': true, 'strong-value': +index === 0 }">{{ item.value }}</p>
        </div>
      </div>
    </div>
    <div class="funnel-right">
      <div v-for="(item, index) in levelFunnelData" :key="index" class="each-level-percent">
        <img :src="require(`../../../assets/img/arrow.png`)" class="transform-arrow" />
        <p class="level-percent-value">{{ item }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FunnelChart',
  components: {},
  props: {
    itemData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
  computed: {
    levelFunnelData() {
      const conversionRates = []
      const { itemData } = this
      for (let i = 1; i < itemData.length; i++) {
        const currentLevel = itemData[i]
        const prevLel = itemData[i - 1]
        if (!prevLel.value) {
          conversionRates.push('0.00%')
        } else {
          const rate = (currentLevel.value / prevLel.value) * 100
          const ratePercent = rate.toFixed(2) + '%'
          conversionRates.push(ratePercent)
        }
      }
      return conversionRates
    },
  },
  created() {},
  methods: {},
}
</script>

<style lang="scss" scped>
.funnel-container {
  margin-top: 36px;
  display: flex;
  justify-content: space-between;
  .funnel-left {
    flex-grow: 1;
    .each-level {
      height: 48px;
      margin-bottom: 16px;
      background: #f9fafd;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 16px;
      .level-name {
        font-family: DiDiSans-Pro-Regular;
        font-size: 24px;
        color: #595c66;
        font-weight: 400;
      }
      .level-value-img {
        position: relative;
        height: 48px;
        .level-img {
          height: 48px;
        }
        .lebel-value {
          position: absolute;
          top: 10px;
          right: 16px;
          font-family: DiDiSans-Pro-Medium;
          font-size: 24px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 30px;
          font-weight: 500;
        }
        .strong-value {
          color: black;
        }
      }
    }
  }
  .funnel-right {
    width: 128px;
    padding: 24px 0px 24px 16px;
    flex-shrink: 0;
    .each-level-percent {
      height: 52px;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      .transform-arrow {
        width: 24px;
        height: 52px;
        margin-left: 16px;
        margin-right: 16px;
      }
      &:first-child,
      &:last-child {
        height: 58px;
        .transform-arrow {
          height: 58px;
        }
      }
      .level-percent-value {
        font-family: DiDiSans-Pro-Regular;
        font-size: 20px;
        color: #282b33;
        letter-spacing: 0;
        line-height: 30px;
        font-weight: 400;
      }
    }
  }
}
</style>
